import { PopoverDesignTokens } from '@primeuix/themes/types/popover';

export const popoverOverride: PopoverDesignTokens = {
  root: {
    background: 'transparent',
    shadow: 'none',
  },
  content: {
    padding: '0',
  },
};
